module.exports = __webpack_public_path__ + "img/app3.d0888f8f.png";